<template>
    <div class="ui items" @click="$emit('click',$event)">
      <div v-if="!dateMin&&!dateMax"><i class="clock outline icon" style="font-size: 1.2em; cursor:pointer"></i></div>
      <template v-else>
        <div class="item"><span>{{dateMin?$moment(dateMin).format(dateTimeFormat):""}}</span></div>
        <div class="item"><span>{{dateMax?$moment(dateMax).format(dateTimeFormat):""}}</span></div>
      </template>

    </div>
</template>

<script>
    export default {
      name: "date-interval-view",
      props:{
        dateMin:{
          type:[Number,Object]
        },
        dateMax:{
          type:[Number,Object]
        },
        dateTimeFormat:{
          type:String,
          default:'DD.MM.YYYY hh:mm:ss'
        }
      }
    }
</script>

<style scoped>

</style>
